module.exports = __webpack_public_path__ + "img/icon-ruler.d671edb.svg";